import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

// modules
import auth from '@/core/auth/index.js';
import header from '@/components/header/store/index.js';
Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: 'rongxin.collect.portal.heilongjiang.state',
  modules: ['auth']
});

export default new Vuex.Store({
  modules: {
    auth,
    header
  },
  plugins: [vuexLocal.plugin]
});
